import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectRegistration } from '../../redux/slices/userSlice';



const useCurrencySymbol = () => {
  const registration=useSelector(selectRegistration);
  const [currencySymbol, setCurrencySymbol] = useState(registration?.CurrencySymbol || '₹'); // Default to Indian Rupee

  // useEffect(() => {
  //   const getSymbolForCountry = (countryCode) => {
  //     const currencyMap = {
  //       'US': '$',      // United States
  //       'IN': '₹',      // India
  //       'GB': '£',      // United Kingdom
  //       // ... other country mappings
  //     };
      
  //     const symbol = currencyMap[countryCode] || '₹'; // Force ₹ as default
  //     console.log(`Setting currency for ${countryCode}: ${symbol}`);
  //     setCurrencySymbol(symbol);
  //   };

  //   const detectCountry = async () => {
  //     try {
  //       // 1. First check timezone (fastest method)
  //       const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //       if (timezone.includes('Asia/Calcutta') || timezone.includes('Asia/Kolkata')) {
  //         console.log("Detected India from timezone");
  //         return getSymbolForCountry('IN');
  //       }

  //       // 2. Check browser's accept-language header
  //       const languages = navigator.languages || [navigator.language];
  //       for (const lang of languages) {
  //         if (lang.includes('-IN')) {
  //           console.log("Detected India from language");
  //           return getSymbolForCountry('IN');
  //         }
  //       }

  //       // 3. IP geolocation fallback
  //       const response = await fetch('https://ipapi.co/json/');
  //       const data = await response.json();
  //       console.log("Geolocation data:", data);
        
  //       // Special handling for India
  //       if (data.country === 'IN' || data.country_name === 'India') {
  //         console.log("Detected India from IP");
  //         return getSymbolForCountry('IN');
  //       }

  //       // Use detected country or default to India
  //       getSymbolForCountry(data?.country || 'IN');

  //     } catch (error) {
  //       console.error('Detection failed, using ₹ as default', error);
  //       getSymbolForCountry('IN'); // Force India on errors
  //     }
  //   };

  //   detectCountry();
  // }, []);

  return currencySymbol;
};

export default useCurrencySymbol;